import Vue from 'vue'

// 获取日期
const getDate = (date) => {
    let year = date.getFullYear()
    let month = formatNum(date.getMonth() + 1)
    let day = formatNum(date.getDate())

    return `${year}-${month}-${day}`
}

// 格式化数字
const formatNum = (num) => {
    return num > 9 ? num : '0' + num
}

Vue.prototype.$getDate = getDate
Vue.prototype.$formatNum = formatNum


// WEBPACK FOOTER //
// ./src/utils/date.js